import React from "react";
import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Layout from "./NewLayout";
import useLogout from "../hooks/useLogout";
import { useClearLogout } from "~/src/hooks/useClearLogout";

const useStyles = makeStyles(({ spacing }) => ({
  messageContainer: {
    display: "flex",
    justifyContent: "center",
    width: spacing(110),
    maxWidth: `calc(100% - ${spacing(5)}px)`,
    margin: "0 auto",
  },
  logoutButton: {
    background: "#000000",
    color: "#FFFFFF",
    borderColor: "#000000",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: ".5rem",
    lineHeight: "1.6",
    padding: "12px 32px",
    borderRadius: "25px",
    fontWeight: 600,
    fontSize: "16px",
    marginBottom: "12px",
    border: "2px solid transparent",
    "&:hover": { background: "#000000" },
    "&.Mui-disabled": {
      color: "#a6a6a6",
      borderColor: "rgba(0, 0, 0, 0.12)",
      backgroundColor: "rgba(0, 0, 0, 0.12)",
    },
  },
}));

const UnAuthorized = () => {
  const { messageContainer, logoutButton } = useStyles();
  const { t } = useTranslation("auth");
  const clearDataOnLogout = useClearLogout();
  const [logout] = useLogout();

  const handleLogout = async () => {
    await clearDataOnLogout();
    await logout();
  };

  return (
    <Layout
      chipText={t("unAuthorized.layoutContainer.title")}
      cursorAfterText={t("unAuthorized.layoutContainer.cursorAfterText")}
      cursorBeforeText={t("unAuthorized.layoutContainer.cursorBeforeText")}
    >
      <Box className={messageContainer} flexDirection="column">
        <Box mb={3}>
          <Typography variant="h5" style={{ fontSize: "18px" }}>
            {t("unAuthorized.message")}
          </Typography>
        </Box>
        <Box>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleLogout}
            className={logoutButton}
          >
            {t("unAuthorized.logoutBtn")}
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default UnAuthorized;
